class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.language = this.dataset.language || '';

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.form = this.querySelector('form');
    this.form.addEventListener(
      'submit',
      this.debounce((event) => {
        event.preventDefault();
        this.onSubmit(event);
      }).bind(this)
    );

    const reqType = this.form.querySelector('input[type="hidden"]').value;
    this.form.addEventListener('keydown', function (e) {
      // Prevent when enter key is pressed
      if (e.key === 'Enter' && reqType != 'product') {
        e.preventDefault();
      }
    });
  }

  connectedCallback() {
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    const reqType = this.input.closest('form').querySelector('input[type="hidden"]').value;
    this.getSearchResults(searchTerm, reqType);
  }

  onSubmit() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      return;
    }

    const redirectPath = this.searchDrivenRedirects(searchTerm);
    if (redirectPath) {
      window.location.href = redirectPath;
    }
  }

  searchDrivenRedirects(query) {
    const searchRedirects = document.getElementById('search-driven-redirects-settings');
    if (!searchRedirects) {
      return null;
    }

    let settings;
    try {
      settings = JSON.parse(searchRedirects.textContent);
    } catch (error) {
      console.error('Failed to parse JSON:', error);
      return null;
    }

    const redirects = settings?.redirects || [];
    const trimmedQuery = query.trim().toLowerCase();

    for (const redirect of redirects) {
      if (redirect.query) {
        const queries = redirect.query.split(',').map((q) => q.trim().toLowerCase());
        if (queries.includes(trimmedQuery)) {
          return redirect.path;
        }
      }
    }

    return null;
  }

  getSearchResults(searchTerm, reqType) {
    let urlParams = '';
    if (reqType == 'product') {
      urlParams =
        'resources[type]=product&resources[options][fields]=title,variants.title,variants.sku,product_type,tag';
    } else if (reqType == 'article') {
      urlParams = 'resources[type]=article';
    } else if (reqType == 'page') {
      urlParams = 'resources[type]=page&resources[options][fields]=title,body';
    }

    fetch(`/search/suggest?q=${searchTerm}&${urlParams}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        // Modify product URLs if language is not English
        if (this.language && this.language !== 'en') this.modifyProductUrls();
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // New method to handle clicks outside the predictive search box
  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.close(); // Close the suggestion box if clicked outside
    }
  }

  // Modify product URLs to prepend language code if language is not English
  modifyProductUrls() {
    const languagePrefix = `/${this.language}`;
    const productLinks = this.predictiveSearchResults.querySelectorAll('a[href*="/products/"]');
    productLinks.forEach((link) => {
      const href = link.getAttribute('href');
      // Only modify if the URL doesn't already start with the language prefix
      if (href && !href.startsWith(languagePrefix) && !href.startsWith('http')) {
        link.setAttribute('href', `${languagePrefix}${href}`);
      }
    });
  }
}

customElements.define('predictive-search', PredictiveSearch);
